module.exports = __webpack_public_path__ + "static/media/7ICJ3.a81207a8.jpg";